import type React from 'react';

import { FieldSet, Label, LabeledControl, Legend, Radio, Text } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import { METHAMPHETAMINE } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function Methamphetamine({ section, setSectionValues }: Props) {
  function onOptionChange(event: React.ChangeEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;
    setSectionValues({
      [METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION]: value === METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION,
      [METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION]: value === METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION,
      [METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION]: value === METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION,
    });
  }

  const currentValue = section.getFieldValue(METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION)
    ? METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION
    : section.getFieldValue(METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION)
      ? METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION
      : section.getFieldValue(METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION)
        ? METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION
        : '';

  return (
    <FieldSet required legend={<Legend>Do you know of any methamphetamine contamination on the property?</Legend>}>
      <LabeledControl
        label={
          <Label>
            No contamination
            <br />
            <Text css={{ color: 'text.subtle' }}>The property has no suspicion of contamination</Text>
          </Label>
        }
        control={
          <Radio
            name="methamphetamine"
            value={METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION}
            checked={currentValue === METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION}
            onChange={onOptionChange}
            disabled={section.isFieldDisabled(METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION)}
          />
        }
      />
      <LabeledControl
        label={
          <Label>
            In process of decontamination
            <br />
            <Text css={{ color: 'text.subtle' }}>
              The property has been found to be contaminated above safe levels and is in the process of decontamination
            </Text>
          </Label>
        }
        control={
          <Radio
            name="methamphetamine"
            value={METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION}
            checked={currentValue === METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION}
            onChange={onOptionChange}
            disabled={section.isFieldDisabled(METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION)}
          />
        }
      />
      <LabeledControl
        label={
          <Label>
            Previous contamination
            <br />
            <Text css={{ color: 'text.subtle' }}>
              The property has been found to be contaminated, but falls within safe levels after tests were conducted
            </Text>
          </Label>
        }
        control={
          <Radio
            name="methamphetamine"
            value={METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION}
            checked={currentValue === METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION}
            onChange={onOptionChange}
            disabled={section.isFieldDisabled(METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION)}
          />
        }
      />
    </FieldSet>
  );
}

Methamphetamine.description = 'Asks Irene whether or not there is meth contamination in the property';

export default Methamphetamine;
